import { AxiosResponse } from 'axios'
import { generalServiceAPI } from '@/store/api-instance'
import { IReportingRequest } from '@/store/modules/reporting/interfaces/api/IReportingRequest'
import { IReportingResponse } from '@/store/modules/reporting/interfaces/api/IReportingResponse'

export const reportingAPI = {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async getPowerBIDetails (dto: Pick<IReportingRequest, 'reportId'>): Promise<IReportingResponse> {
    let response: AxiosResponse<IReportingResponse>
    localStorage.setItem('exceedTimeout', '88000')

    try {
      if (dto.reportId === 'SalesReport') {
        response = await generalServiceAPI.get('/power-bi/sales-report')
      } else {
        response = await generalServiceAPI.get(`power-bi/sales-report-external?reportName=${dto.reportId}`)
      }

      return response.data
    } catch (error) {
      console.error('Error fetching Power BI details:', error)
      throw error
    }
  }
}
